var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "main",
    { staticClass: "picking-v2" },
    [
      _c("h1", [_vm._v("Order picking")]),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "picking-v2__panel picking-v2__search-panel" },
        [
          _c("label", { attrs: { for: "picking-reference" } }, [
            _vm._v("Zoek een picklijst"),
          ]),
          _vm._v(" "),
          _c(
            "form",
            {
              staticClass: "picking-v2__search",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.openPicking.apply(null, arguments)
                },
              },
            },
            [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.reference,
                    expression: "reference",
                    modifiers: { trim: true },
                  },
                ],
                ref: "reference",
                attrs: {
                  id: "picking-reference",
                  autocomplete: "off",
                  placeholder:
                    "Ordernummer, extern ordernummer of picklijstcode",
                  disabled: _vm.claiming,
                },
                domProps: { value: _vm.reference },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.reference = $event.target.value.trim()
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "picking-v2__primary",
                  attrs: { type: "submit", disabled: _vm.claiming },
                },
                [
                  _c(
                    "i",
                    {
                      staticClass: "ak-icon",
                      attrs: { "aria-hidden": "true" },
                    },
                    [_vm._v("search")]
                  ),
                  _vm._v(
                    "\n                " +
                      _vm._s(_vm.claiming ? "Openen…" : "Open picklijst") +
                      "\n            "
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _vm.message
            ? _c(
                "p",
                {
                  staticClass: "picking-v2__message",
                  attrs: { role: "alert" },
                },
                [_vm._v(_vm._s(_vm.message))]
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("section", { staticClass: "picking-v2__panel" }, [
        _c("h2", [_vm._v("Voltooide picklijsten")]),
        _vm._v(" "),
        _vm.loading
          ? _c("p", { staticClass: "picking-v2__empty" }, [
              _vm._v("Picklijsten laden…"),
            ])
          : !_vm.recent.length
          ? _c("p", { staticClass: "picking-v2__empty" }, [
              _vm._v("Je hebt nog geen picklijsten voltooid."),
            ])
          : _c(
              "div",
              { staticClass: "picking-v2__recent" },
              _vm._l(_vm.recent, function (entry) {
                return _c(
                  "article",
                  { key: entry.id, staticClass: "picking-v2__recent-row" },
                  [
                    _c("div", { staticClass: "picking-v2__recent-details" }, [
                      _c("strong", [_vm._v(_vm._s(entry.customerName))]),
                      _vm._v(" "),
                      _c(
                        "span",
                        { staticClass: "picking-v2__recent-reference" },
                        [
                          _vm._v("Bestelling " + _vm._s(entry.orderCode) + " "),
                          _c(
                            "span",
                            { staticClass: "picking-v2__recent-picking-code" },
                            [_vm._v("· Picklijst " + _vm._s(entry.code))]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      entry.hasPartialDelivery
                        ? _c(
                            "i",
                            {
                              staticClass:
                                "ak-icon text--color-warning picking-v2__partial",
                              attrs: {
                                title: "Deellevering",
                                "aria-label": "Deellevering",
                              },
                            },
                            [_vm._v("warning")]
                          )
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "picking-v2__actions" },
                      [
                        _c(
                          "button",
                          {
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.print(entry, "picking-list")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "ak-icon" }, [
                              _vm._v("print"),
                            ]),
                            _vm._v(" Picklijst"),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.print(entry, "shipping-list")
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "ak-icon" }, [
                              _vm._v("print"),
                            ]),
                            _vm._v(" Leverbon"),
                          ]
                        ),
                        _vm._v(" "),
                        entry.hasShippingLabels
                          ? _c(
                              "button",
                              {
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return _vm.print(entry, "shipping-label")
                                  },
                                },
                              },
                              [
                                _c("i", { staticClass: "ak-icon" }, [
                                  _vm._v("print"),
                                ]),
                                _vm._v(" Verzendlabel"),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("router-link", { attrs: { to: entry.detailPath } }, [
                          _c("i", { staticClass: "ak-icon" }, [
                            _vm._v("zoom_in"),
                          ]),
                          _vm._v(" Bekijk order"),
                        ]),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
      ]),
      _vm._v(" "),
      _vm.printError
        ? _c(
            "p",
            { staticClass: "picking-v2__toast", attrs: { role: "alert" } },
            [_vm._v(_vm._s(_vm.printError))]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.picking && !_vm.isCompleted
        ? _c("picking-v2-form", {
            attrs: {
              picking: _vm.picking,
              saving: _vm.saving,
              fields: _vm.fieldErrors,
              error: _vm.modalError,
            },
            on: {
              close: _vm.closePicking,
              "open-order": _vm.openOrder,
              save: _vm.completePicking,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.picking && _vm.isCompleted
        ? _c("picking-v2-completed", {
            attrs: {
              picking: _vm.picking,
              printing: _vm.printing,
              error: _vm.printError,
            },
            on: {
              close: _vm.newPicking,
              new: _vm.newPicking,
              print: function ($event) {
                return _vm.print(_vm.picking, $event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }